import { useAuth } from './useAuth.tsx';

export function useCurrentUser() {
  const { user, role, refreshCurrentUser } = useAuth();
  return { user, role, refreshCurrentUser };
}
